import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogResponse, DigitalSignaturStatus } from "~app/common/models/constants";
import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { VirkeskopskontraktDigitalSigneringViewModel } from "~app/features/virkeskop/models/kontrakt-models";

@Component({
    selector: "rask-kontrakt-digitalsignering-prolong-dialog",
    templateUrl: "./kontrakt-digitalsignering-prolong-dialog.component.html",
    styleUrl: "./kontrakt-digitalsignering-prolong-dialog.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class KontraktDigitalsigneringProlongDialogComponent {
    data: VirkeskopskontraktDigitalSigneringViewModel;

    protected antalDagar?: number;

    private readonly modal = inject(NgbActiveModal);

    abort() {
        this.modal.close(ConfirmDialogResponse.cancel);
    }

    getEndDate() {
        // Om datum förfallit förlängs signerings tiden med x antal dagar från dagens datum annars befintligt förfallo datum
        const calcDate = this.data.signingProviderStatus === DigitalSignaturStatus.overdue ? new Date() : this.data.forfalloDatum;
        return ObjectUtils.hasValue(this.antalDagar) ?
            DateUtils.shortDateString(DateUtils.AddDays(calcDate, this.antalDagar)) : DateUtils.shortDateString(this.data.forfalloDatum);
    }

    save() {
        this.modal.close(this.antalDagar);
    }
}
